/**
 * Generated by orval. Do not edit manually.
 */

export type CustomerFormStatus = (typeof CustomerFormStatus)[keyof typeof CustomerFormStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerFormStatus = {
  active: 'active',
  inactive: 'inactive',
  cancelled: 'cancelled',
} as const
